import LegalPage from './LegalPage';

// Mirrors the LAUNCHED flag in LandingPage.jsx — flip to true at iOS launch.
const LAUNCHED = false;

export default function Privacy() {
  const file = LAUNCHED ? '/legal/privacy-launched.md' : '/legal/privacy-prelaunch.md';
  return <LegalPage file={file} title="Privacy Policy" />;
}
